import React from 'react';
import { Grid, Typography } from '@mui/material';
import Button from 'components/atoms/Button';
import { EButtonSizesPX, EButtonStyleVariant, EButtonVariants } from 'constants/Buttons';
import { EIconTypes } from 'constants/Icons';
import { StyledTitle } from 'pages/DashboardPage/styles';

const DashboardGeneralEnquiries = () => (
  <Grid container rowGap="20px">
    <Grid item xs={12}>
      <StyledTitle variant="h4">General enquiries</StyledTitle>
    </Grid>
    <Grid item xs={12} mb="20px">
      <Typography variant="body1">Contact the firearms licensing team.</Typography>
    </Grid>
    <Grid item container xs={12} columnSpacing="20px">
      <Grid item xs={12} md={6} lg={4}>
        <Button
          id="contact"
          variant={EButtonVariants.contained}
          label="Contact"
          onClick={() => {}}
          icon={EIconTypes.arrowRightLink}
          endIcon={true}
          fullWidth
          sizePX={EButtonSizesPX.px48}
          styleVariant={EButtonStyleVariant.success}
        />
      </Grid>
    </Grid>
  </Grid>
);

export { DashboardGeneralEnquiries };
